// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';

// ----------------------------------------------------------------------

interface RHFCheckboxProps extends Omit<FormControlLabelProps, 'control'> {
    name: string;
    disabled?: boolean;
    onChange?: (newValue: any) => void;
}

export function RHFCheckbox({ name, disabled, onChange, ...other }: RHFCheckboxProps) {
    const { control } = useFormContext();

    return (
        <FormControlLabel
            control={
                <Controller
                    name={name}
                    control={control}
                    render={({ field }) => (
                        <Checkbox
                            {...field}
                            disabled={disabled}
                            checked={field.value}
                            onChange={(_, newValue) => {
                                newValue = newValue ?? false;
                                field.onChange(newValue);
                                if (onChange) {
                                    onChange(newValue);
                                }
                            }}
                        />
                    )}
                />
            }
            {...other}
        />
    );
}

// ----------------------------------------------------------------------

